import { type MCPServerInfo } from '../../types';

const ExcalidrawServer: MCPServerInfo = {
  serverId: 'EXCALIDRAW',
  name: 'Excalidraw',
  slug: 'excalidraw',
  description:
    'Excalidraw MCP App Server - stream hand-drawn diagrams with interactive fullscreen editing',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/excalidraw/excalidraw-mcp',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@mcp-demos/excalidraw-server'
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default ExcalidrawServer;
